<style lang="scss" scoped>
@import "$vars";
.card {
  .card-body {
    padding: 0 30px 30px 30px;
    >ul {
      margin: 0
    }
  }
  h2 {
    font-family: $font1 !important;
    color: #4a4a4a;
    font-size: 1.8em;
    font-weight: 700;
    margin: 0;
  }
  .card-header {
    margin-bottom: 35px;
    >section {
      align-items: flex-end;
    }
    .avatar-block {
      position: relative;
      width: 5rem;
      height: 5rem;
      .avatar {
        width: 5rem;
        height: 5rem;
        border-radius: 8px;
        background-color: transparent;
      }
      .avatar-edit {
        border-radius: 0 0 8px 8px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1rem;
        background-color: rgba(0, 0, 0, 0.46);
        text-align: center;
        color: #fff;
        font-weight: bold;
        font-size: 0.8em;
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    aside {
      display: flex;
      align-items: flex-end;
      padding-bottom: 10px;
      a > div {
        width: 100%;
        figure {
          width: 30px;
        }
        &:last-child {
          .v-icon {
            width: 16px;
            margin: 0 7px;
          }
        }
      }
      h4 {
        margin: 0;
        text-decoration: underline;
        font-size: 1em;
        font-family: $font1;
        font-weight: bold;
      }
    }
  }
  p {
    margin: 5px 0 10px;
  }
  figcaption {
    padding-left: 1em;
  }
  .columns {
    padding-right: 10%
  }
  .chip {
    background: $color-blue;
    padding: 3px 6px;
    font-weight: bold;
    font-size: 0.6em;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .icon {
    height: 20px;
  }
}
</style>

<template>
  <main class="main card" v-if="loaded">
    <header class="card-header">
      <h1>Minha conta</h1>
      <section class="columns">
        <figure class="d-flex col-10 profile-block">
          <div class="avatar-block">
            <img class="avatar" :src="getProfile.picture">
            <span class="avatar-edit" @click="modalUserImage = true">Editar</span>
            <user-image
              :active="modalUserImage"
              @status="modalUserImage = $event"
              :image="getProfile.picture"
              @newImage="fetchUser()"
            />
          </div>
          <figcaption>
            <h2>{{getProfile.name}}</h2>
          </figcaption>
        </figure>
      </section>
    </header>
    <div class="card-body">
      <form @submit.prevent="submit()" class="columns" v-if="!isChangePassword">
        <dr-field
          prefix="form1"
          class="text-left"
          v-for="(field, name) in formData"
          v-bind:form.sync="formData"
          v-bind:field.sync="field"
          v-bind:value.sync="formData[name].value"
          v-bind:validators.sync="$v.formData[name]"
          v-bind:apiErrors.sync="apiErrors[name]"
          :id="name"
          :ref="name"
          :key="'main_'+name">
        </dr-field>
        <p class="text-warning col-12 text-center" v-if="$v.$invalid && sending">Por favor complete o formulário corretamente</p>
        <span class="col-12">
          <br />
          <dr-submit :disabled="$v.$invalid" text="Salvar" :sending="sending"></dr-submit>
          &emsp;&emsp;<a @click="isChangePassword = true"><strong>Alterar senha</strong></a>
        </span>
      </form>
      <changePassword @change="isChangePassword = false" v-else />
    </div>
  </main>
</template>

<script>
import userImage from '@/components/modals/userImage'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import changePassword from '@/components/layout/user/changePassword.vue'
import {formData, validations} from '@/data/formData/userSecretary'

export default {
  components: {
    userImage,
    drField,
    drSubmit,
    changePassword
  },
  data () {
    return {
      modalUserImage: false,
      loaded: false,
      isChangePassword: false,
      showForm: true,
      formData: formData,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      sending: false
    }
  },
  validations: {
    formData: validations
  },
  computed: {
    watchCep () {
      return this.formData[`address.cep`].value
    },
    getProfile () {
      return this.$store.getters.getProfile
    }
  },
  mounted () {
    this.fetchUser()
  },
  watch: {
    'watchCep': function (next, prev) {
      if (next.length === 9) {
        this.getCep(next)
      }
    }
  },
  methods: {
    fetchUser () {
      this.$http.get('/secretary', this.$store.getters.getAuthHeader).then(
        (res) => {
          res.data.profile_picture = process.env.ROOT_API + '/upload/user/profile_picture/' + res.data.user.profile_picture
          let profile = {
            id: res.data.id,
            name: res.data.user.name,
            picture: res.data.profile_picture
          }
          this.$store.dispatch('setUserProfile', profile)
          this.fn_FLATTEN_OBJECT(res.data.user).then(
            (data) => {
              data.dateOfBirth = this.$root.$options.filters.TO_DATE(data.dateOfBirth)
              for (let field in data) {
                if (this.formData[field]) {
                  this.formData[field].value = data[field]
                }
              }
              this.loaded = true
              this.fn_HIDE_PROGRESS()
            }
          )
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      )
    },
    submit () {
      this.apiErrors = this.fn_BUILD_API_ERRORS(formData)
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      this.fn_SHOW_PROGRESS()
      let data = this.fn_COPY_OBJECT(this.formData)

      data['contactPhone'].value = this.fn_NUMBERS_ONLY(data['contactPhone'].value)
      data = this.fn_EXPAND_OBJECT(data)
      delete data.cpf
      data.address.latitude = 0
      data.address.longitude = 0
      let predate = data.dateOfBirth.split('/')
      data.dateOfBirth = `${predate[2]}-${predate[1]}-${predate[0]}`

      this.$http.put('/secretary', {'secretary': data}, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Dados alterados com sucesso',
            size: 'md',
            active: true
          })
          this.$store.dispatch('updateUserProfile', {name: this.formData['name'].value})
        }
      ).catch(
        (err) => {
          console.log(err, data)
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
              }
            )
          } else {
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        }
      ).finally(
        () => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
        }
      )
    },
    getCep (v) {
      const self = this
      self.formData['address.cep'].loading = 1
      function handleData (res) {
        if (!res) {
          self.formData['address.cep'].loading = 0
          self.validCep = false
          return
        }
        let cep = {}
        if (res.data.erro) {
          self.validCep = false
          cep.uf = ''
        } else {
          self.validCep = true
          cep = res.data
          cep.uf = self.fn_FIND_UF_CODE(cep.uf).id
        }
        self.formData['address.city.name'].value = cep.localidade || null
        self.formData['address.uf'].value = cep.uf || null
        self.formData['address.district'].value = cep.bairro || null
        self.formData['address.street'].value = cep.logradouro || null
      }
      if (v.length === 9) {
        this.$http.get('https://viacep.com.br/ws/' + v.replace('-', '') + '/json/').then(
          (res) => {
            self.formData['address.cep'].loading = 0
            if (res.data.erro) {
              this.validCep = false
              return
            }
            handleData(res)
          }
        ).catch(
          (err) => {
            handleData()
            console.log(err)
          }
        ).finally(() => {
          this.fn_HIDE_PROGRESS()
        })
      }
    }
  }
}
</script>
